import z from "zod";
import { OrgTeamFilterParamsSchema } from "rdx/modules/enterprisePersonnel/schemas";
import ZodSchemaUtil from "util/schema-helpers/ZodSchemaUtil";
import {
  OrgCompletedFilterParamsSchema,
  OrgPostSalesFilterParamsSchema,
  OrgPreSalesFilterParamsSchema,
} from "../enterpriseProjects/schemas";
import { CsvJobStateEnum, CsvJobNameEnum, CsvReportNameEnum, CsvJobNameKeyEnum } from "./enums";

export const CsvJobStateSchema = z.nativeEnum(CsvJobStateEnum);
export const CsvJobNameSchema = z.nativeEnum(CsvJobNameEnum);
export const CsvReportNameSchema = z.nativeEnum(CsvReportNameEnum);

export const GetTeamUsersCsvParamsSchema = z.object({
  filterParams: OrgTeamFilterParamsSchema,
  searchedUserId: z.union([z.number(), z.null()]),
  isEnterprise: z.boolean(),
});

export const GetOrgProjectsCsvParamsSchema = z.object({
  filterParams: OrgPreSalesFilterParamsSchema.or(OrgPostSalesFilterParamsSchema).or(OrgCompletedFilterParamsSchema),
  tab: ZodSchemaUtil.makeStringLiteralUnion(["pre_sales", "post_sales", "completed"]),
});

export const CsvJobSchema = z.object({
  results: z.boolean().optional(),
  state: CsvJobStateSchema.nullable(),
  ts: z.string(),
});

export const CsvReportSchema = z.object({
  createdAt: z.string(),
  id: z.number(),
  jobName: CsvJobNameSchema.nullable(),
  name: ZodSchemaUtil.makeStringLiteralUnion([
    CsvReportNameEnum.TEAM_USERS,
    CsvReportNameEnum.ORG_TEAM_USERS,
    CsvReportNameEnum.ORG_PRE_SALES_PROJECTS,
    CsvReportNameEnum.ORG_POST_SALES_PROJECTS,
    CsvReportNameEnum.ORG_COMPLETED_PROJECTS,
  ]),
  url: z.string().nullable(),
  jobStatus: z.string().nullish(),
});

export const GetCsvReportByIdResponseSchema = z.object({
  status: z.number(),
  body: z.object({
    report: CsvReportSchema,
  }),
});

export const TeamUsersCsvSchema = CsvReportSchema.extend({
  jobs: z.object({
    [CsvJobNameKeyEnum.TEAM_USERS]: CsvJobSchema,
  }),
  name: ZodSchemaUtil.makeStringLiteralUnion([CsvReportNameEnum.TEAM_USERS, CsvReportNameEnum.ORG_TEAM_USERS]),
  updatedAt: z.string(),
  userId: z.number(),
});

export const OrgProjectsCsvSchema = CsvReportSchema.extend({
  jobs: z.object({
    [CsvJobNameKeyEnum.PROJECTS]: CsvJobSchema,
  }),
  name: ZodSchemaUtil.makeStringLiteralUnion([
    CsvReportNameEnum.ORG_PRE_SALES_PROJECTS,
    CsvReportNameEnum.ORG_POST_SALES_PROJECTS,
    CsvReportNameEnum.ORG_COMPLETED_PROJECTS,
  ]),
  updatedAt: z.string(),
  userId: z.number(),
});

export const GetTeamUsersCsvResponseSchema = z.object({
  status: z.number(),
  body: z.object({
    csv: TeamUsersCsvSchema,
  }),
});

export const GetOrgProjectsCsvResponseSchema = z.object({
  status: z.number(),
  body: z.object({
    csv: OrgProjectsCsvSchema,
  }),
});
